export default __webpack_public_path__ + "e0a0f854b6ad17d82d130c9395f134c6.woff";